/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */

import singleDeviceTemplate from './single-device.tpl.html';
import singleDevicetToolbarTemplate from './single-device-toolbar.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.farmer.singleDevice', [])
    .directive('singleDevice', SingleDevice)
    .name;

/*@ngInject*/
function SingleDevice() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '=',
            device: '='
        },
        controller: SingleDeviceController,
        controllerAs: 'vm',
        templateUrl: singleDeviceTemplate
    };
}

/* eslint-disable angular/angularelement */

/*@ngInject*/
function SingleDeviceController($scope, $element, $compile, $templateCache, agTypes) {

    let vm = this;

    vm.agTypes = agTypes;
    let parents = $element.parents('.tb-widget');
    parents.children('.tb-widget-header').css('paddingRight', '40px');
    $element.parents('.tb-widget-content').css('paddingRight', '40px');

    let toolbarTemplate = $templateCache.get(singleDevicetToolbarTemplate);
    let toolbarElement = angular.element(toolbarTemplate);
    angular.element(parents[1]).append(toolbarElement);
    $compile(toolbarElement.contents())($scope);

    $scope.$watch('vm.ctx', () => {
        if (vm.ctx) {
            vm.ctx.spearWidgetTypes = agTypes.spearWidgetType;
            vm.ctx.currentWidgetType = agTypes.spearWidgetType.deviceOverview;
        }
    });
}